import React from 'react';
import App from './App';
import { render } from 'react-dom';

render(<App />, document.querySelector('#main'));
